import { isly } from "isly";
export var DateSpan;
(function (DateSpan) {
    var _a;
    _a = isly
        .object({
        years: isly.number().optional(),
        months: isly.number().optional(),
        days: isly.number().optional(),
    })
        .bind(), DateSpan.type = _a.type, DateSpan.is = _a.is, DateSpan.flawed = _a.flawed;
})(DateSpan || (DateSpan = {}));
//# sourceMappingURL=index.js.map